import PropTypes from 'prop-types';
import React from 'react';
import FeaturedEventFlagSVG from '../../../FeaturedEventFlagSVG/FeaturedEventFlagSVG';

import './DateDisplay.scss';

export default class DateDisplay extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        month: PropTypes.string,
        day: PropTypes.number,
        isFeatured: PropTypes.oneOf([1, 0]),
    };

    render() {
        return (
            <div className="component-Events-SingleEventComponent-DateDisplay">
                <div className="dateDisplay-container">
                    <div className="dateDisplay-month-display">
                        {this.props.month}
                    </div>
                    <div className="dateDisplay-day-display">
                        {this.props.day}
                    </div>
                </div>
                {this.props.isFeatured ? <FeaturedEventFlagSVG /> : null}
            </div>
        );
    }
}
